import { Configuration } from "./types";

export function objectValues(source: { [key: string]: any }): any[] {
    if (!source) {
        return [];
    }
    return Object.keys(source).map((key) => source[key]);
}

export function objectClone(obj: { [key: string]: any }): any {
    let result;
    try {
        result = JSON.parse(JSON.stringify(obj || {}));
    } catch (error) {
        result = {};
    }

    return result;
}

export function validate<T>(callback: (item: T) => any, configuration: Configuration) {
    if (configuration.throwErrors) {
        if (typeof callback !== "function") {
            throw new Error("Please provide the callback as a function!");
        }
    }
}
